import BitcoinLogo from "assets/images/PaymentMethods/PaymentLogos/BitcoinLogo";
import TetherLogo from "assets/images/PaymentMethods/PaymentLogos/TetherLogo";
import TronLogo from "assets/images/PaymentMethods/PaymentLogos/TronLogo";
import LitecoinLogo from "assets/images/PaymentMethods/PaymentLogos/LitecoinLogo";
import { useEffect, useState } from "react";
import {
  InputGroup,
  Input,
  InputRightElement,
  Button,
  Text,
  Box,
  useToast,
  InputLeftElement,
} from "@chakra-ui/react";

const InvoiceForm = ({ network, coin, amount, address }) => {
  const toast = useToast({
    position: "top",
    title: "Address copied to clipboard!",
    isClosable: true,
    status: "success",
    duration: 1500,
    containerStyle: {
      width: "210px",
      maxWidth: "100%",
    },
  });
  const [logoCoin, setLogoCoin] = useState(null);
  const [logoNetwork, setLogoNetwork] = useState(null);

  useEffect(() => {
    if (!coin) {
      setLogoCoin(null);
      return;
    }
    switch (coin.toLowerCase()) {
      case "btc":
        setLogoCoin(<BitcoinLogo />);
        break;
      case "usdt":
        setLogoCoin(<TetherLogo />);
        break;
      case "trx":
        setLogoCoin(<TronLogo />);
        break;
      case "ltc":
        setLogoCoin(<LitecoinLogo />);
        break;
      default:
        break;
    }
  }, [coin]);

  useEffect(() => {
    if (!network) {
      setLogoNetwork(null);
      return;
    }
    switch (network.toLowerCase()) {
      case "tron":
        setLogoNetwork(<TronLogo />);
        break;
      case "bitcoin":
        setLogoNetwork(<BitcoinLogo />);
        break;
      case "litecoin":
        setLogoNetwork(<LitecoinLogo />);
        break;
    }
  }, [network]);
  return (
    <Box>
      <Text textColor="text.secondary" textAlign="left" mb={1}>Network</Text>
      <InputGroup size="md">
        <Input
          isReadOnly={true}
          value={network || "Not selected"}
          placeholder="Not selected"
          css={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        />
        {logoNetwork && <InputLeftElement children={logoNetwork} />}
      </InputGroup>
      <Text textColor="text.secondary" textAlign="left" mb={1}>
        Currency
      </Text>
      <InputGroup size="md">
        <Input
          isReadOnly={true}
          value={coin || "Not selected"}
          placeholder="Not selected"
          css={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        />
        {logoCoin && <InputLeftElement children={logoCoin} />}
      </InputGroup>
      <Text textColor="text.secondary" textAlign="left" mb={1}>
        Send this amount
      </Text>
      <InputGroup size="md">
        <Input
          isReadOnly={true}
          value={amount || "Not specified"}
          placeholder="Not specified"
          css={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        />

        <InputRightElement width="4.5rem">
          <Button
            h="1.75rem"
            size="sm"
            onClick={() => {
              if (amount) {
                navigator.clipboard.writeText(amount);
                toast();
              }
            }}
            isDisabled={!amount}
          >
            Copy
          </Button>
        </InputRightElement>
      </InputGroup>
      <Text textColor="text.secondary" textAlign="left" mt={5} mb={1}>
        To this address
      </Text>
      <InputGroup size="md">
        <Input
          value={address || "Not specified"}
          placeholder="Not specified"
          isReadOnly={true}
          pr={20}
          css={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        />
        <InputRightElement width="4.5rem">
          <Button
            h="1.75rem"
            size="sm"
            onClick={() => {
              if (address) {
                navigator.clipboard.writeText(address);
                toast();
              }
            }}
            isDisabled={!address}
          >
            Copy
          </Button>
        </InputRightElement>
      </InputGroup>
    </Box>
  );
};

export default InvoiceForm;
